export default {
  status: {
    open: 'Otwarte',
    closed: 'Zamknięte',
  },
  offline_until: 'Offline do',
  closed_until: 'Zamknięte do',
  online_orders_paused: 'Zamówienia online wstrzymane',
  online_orders_paused_until: 'Zamówienia online wstrzymane do',
  reopens: 'Otwiera się ponownie',
  opens_today: 'Otwarte dzisiaj',
  opens: 'Otwiera się',
  open: 'Otwarte',
  open_whole_day: 'Otwarte cały dzień',
  outside_ordering_times: 'Poza godzinami zamawiania',
};
